module.exports = {
  roastedPork: 0, // 要烤出一條脆皮豬
  followUs: 1, // 關注我們
  join: 2, // 加盟優勢
}
